// ABOUTME: Route for /library/$documentId/chunks.
// ABOUTME: Renders the DocumentChunks component showing all chunks from a document.

import DocumentChunks from "@/components/DocumentChunks";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/library/$documentId/chunks",
)({
  component: DocumentChunks,
});
